import React from 'react';
import UserHeader from '../components/UserHeader';
import UserFooter from '../components/UserFooter';
import '../styles/AboutUs.css';

const AboutUs = () => {
  return (
    <div className="aboutus-screen">
      <UserHeader />

      {/* Hero Section */}
      <section className="aboutus-hero">
        <div className="aboutus-hero-content">
          <div className="aboutus-hero-text">
            <h1 className="aboutus-hero-title">About LegacyStat</h1>
            <p className="aboutus-hero-description">
              Where verified stats, athlete growth, and family<br />
              safety come together.
            </p>
          </div>

          <div className="aboutus-hero-image">
            <img src="/assets/images/aboutus-logo.png" alt="LegacyStat Logo" />
          </div>
        </div>
      </section>

      {/* What is LegacyStat Section */}
      <section className="aboutus-what">
        <div className="aboutus-what-container">
          <div className="aboutus-what-images">
            <div className="aboutus-what-image-top">
              <img src="/assets/images/aboutus-athlete.png" alt="Athlete" />
            </div>
            <div className="aboutus-what-image-bottom">
              <img src="/assets/images/aboutus-logo-card.png" alt="LegacyStat Logo" />
            </div>
          </div>

          <div className="aboutus-what-content">
            <h2 className="aboutus-what-title">What is LegacyStat?</h2>
            <p className="aboutus-what-description">
              LegacyStat brings verified stats, highlight sharing, and secure family oversight into one simple platform. Built for youth sports, designed for transparency, and powered by coach-verified data.
            </p>
          </div>
        </div>
      </section>

      {/* Empowering Athletes Section */}
      <section className="aboutus-empowering">
        <div className="aboutus-empowering-container">
          <div className="aboutus-empowering-image">
            <img src="/assets/images/empowering-athlete.png" alt="Athlete" />
          </div>

          <div className="aboutus-empowering-content">
            <p className="aboutus-empowering-label">For Athletes</p>
            <h2 className="aboutus-empowering-title">Empowering Athletes</h2>
            <p className="aboutus-empowering-description">
              LegacyStat gives athletes a powerful way to showcase their talent with verified stats, high-quality highlights, and collectible Fan Packs. Every athlete gets a personalized profile where their coach-verified performance, achievements, and best moments can be shared publicly. With tools built for growth, visibility, and credibility, athletes can build their brand, reach new audiences, and take control of their sports journey all in a safe, supportive environment.
            </p>
          </div>
        </div>
      </section>

      <UserFooter />
    </div>
  );
};

export default AboutUs;
